export const FETCH_PAGES = 'facebook/FETCH_PAGES'
export const FETCH_PAGES_STARTED = 'facebook/FETCH_PAGES_STARTED'
export const FETCH_PAGES_SUCCESS = 'facebook/FETCH_PAGES_SUCCESS'
export const FETCH_PAGES_FAILED = 'facebook/FETCH_PAGES_FAILED'

export const BULK_UPDATE_PAGES = 'facebook/BULK_UPDATE_PAGES'
export const BULK_UPDATE_PAGES_STARTED = 'facebook/BULK_UPDATE_PAGES_STARTED'
export const BULK_UPDATE_PAGES_SUCCESS = 'facebook/BULK_UPDATE_PAGES_SUCCESS'
export const BULK_UPDATE_PAGES_FAILED = 'facebook/BULK_UPDATE_PAGES_FAILED'
